angular.module('unergie.main')
.factory('StringUtils', () => {
    const unaccent = (s) => {
        return (s && s.normalize('NFD').replace(/[\u0300-\u036f]/g, '')) || s
    }

    const leftPad = function (string, pad) {
        const s = String(string)
        return pad.substring(0, pad.length - s.length) + s
    }

    const randomIntString = (digit) => {
        return `${Math.floor(Math.random() * Math.pow(10, digit))}`.padStart(digit, '0')
    }

    return {
        unaccent,
        leftPad,
        randomIntString,
    }
})
